var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selection
    ? _c(
        "div",
        {
          staticClass: "selection-component",
          class: { "team-logos": _vm.teamLogoVisibility },
          attrs: {
            idfoselection:
              (_vm.selection &&
                _vm.selection.idfoselection &&
                _vm.selection.idfoselection.toString()) ||
              "null"
          }
        },
        [
          _vm.showselectionname
            ? _c("div", { staticClass: "selectionname" }, [
                _vm.showparticipantlogo
                  ? _c("span", {
                      staticClass: "team-logo",
                      style: _vm.teamLogoStyle
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "text-overflow" }, [
                  _vm._v(_vm._s(_vm.selection.name))
                ]),
                _vm._v(" "),
                _vm.isoutright &&
                _vm.showParticipantStats &&
                _vm.participantWins &&
                _vm.participantLosses
                  ? _c("span", { staticClass: "stats" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.participantWins) +
                          " - " +
                          _vm._s(_vm.participantLosses) +
                          "\n      "
                      ),
                      _vm.participantTies
                        ? _c("span", [
                            _vm._v(" - " + _vm._s(_vm.participantTies))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.participantOvertimeLosses
                        ? _c("span", [
                            _vm._v(
                              " - " + _vm._s(_vm.participantOvertimeLosses)
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showshortselectionname
            ? _c("div", { staticClass: "selectionname" }, [
                _vm.showparticipantlogo
                  ? _c("span", {
                      staticClass: "team-logo",
                      style: _vm.teamLogoStyle
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "text-overflow" }, [
                  _vm._v(_vm._s(_vm.selection.shortname))
                ]),
                _vm._v(" "),
                _vm.isoutright &&
                _vm.showParticipantStats &&
                _vm.participantWins &&
                _vm.participantLosses
                  ? _c("span", { staticClass: "stats" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.participantWins) +
                          " - " +
                          _vm._s(_vm.participantLosses) +
                          "\n      "
                      ),
                      _vm.participantTies
                        ? _c("span", [
                            _vm._v(" - " + _vm._s(_vm.participantTies))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.participantOvertimeLosses
                        ? _c("span", [
                            _vm._v(
                              " - " + _vm._s(_vm.participantOvertimeLosses)
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "selectionlistcode" }, [
            _c("span", { staticClass: "text-overflow" }, [
              _vm._v(_vm._s(_vm.selection.listcode || "-"))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "value",
              class: [
                { "show-one-in-one-line": _vm.showOneInOneLine },
                {
                  suspended:
                    !_vm.istradable ||
                    _vm.selection.idfobolifestate === "NR" ||
                    _vm.selection.idfoselectionsuspensiontype
                },
                _vm.priceChange
              ]
            },
            [
              _vm.istradable &&
              _vm.selection.idfobolifestate !== "NR" &&
              !_vm.selection.idfoselectionsuspensiontype
                ? _c(
                    "div",
                    {
                      staticClass: "selectionprice",
                      class: {
                        noprice: !_vm.formatedSelectionPrice,
                        "with-handicap":
                          _vm.currentMatchHandicap ||
                          (_vm.currentMatchHandicap === 0 &&
                            ["H", "D", "A"].indexOf(_vm.selection.hadvalue) >
                              -1),
                        longprice:
                          _vm.formatedSelectionPrice &&
                          _vm.formatedSelectionPrice.length >
                            _vm.selectionLength
                      }
                    },
                    [
                      _vm.currentMatchHandicap ||
                      (_vm.currentMatchHandicap === 0 &&
                        ["H", "D", "A"].indexOf(_vm.selection.hadvalue) > -1)
                        ? _c("span", { staticClass: "currenthandicap" }, [
                            ["O", "U"].indexOf(_vm.selection.hadvalue) > -1
                              ? _c("div", { staticClass: "had-value" }, [
                                  _vm.selection.hadvalue == "O"
                                    ? _c("span", [
                                        _vm.brand_translux1
                                          ? _c("span", [_vm._v("O")])
                                          : _c("span", [_vm._v("Ov")])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.selection.hadvalue == "U"
                                    ? _c("span", [
                                        _vm.brand_translux1
                                          ? _c("span", [_vm._v("U")])
                                          : _c("span", [_vm._v("Un")])
                                      ])
                                    : _vm._e()
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            ["O", "U"].indexOf(_vm.selection.hadvalue) > -1
                              ? _c(
                                  "div",
                                  { staticClass: "uo-currenthandicap" },
                                  [_vm._v(_vm._s(_vm.currentMatchHandicap))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            ["H", "D"].indexOf(_vm.selection.hadvalue) > -1
                              ? _c(
                                  "div",
                                  [
                                    _vm.currentMatchHandicap !== 0
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentMatchHandicap > 0
                                                ? "+" + _vm.currentMatchHandicap
                                                : "" + _vm.currentMatchHandicap
                                            )
                                          )
                                        ]
                                      : [_vm._v("PK")]
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            ["A"].indexOf(_vm.selection.hadvalue) > -1
                              ? _c(
                                  "div",
                                  [
                                    _vm.currentMatchHandicap !== 0
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentMatchHandicap * -1 > 0
                                                ? "+" +
                                                    _vm.currentMatchHandicap *
                                                      -1
                                                : "" +
                                                    _vm.currentMatchHandicap *
                                                      -1
                                            )
                                          )
                                        ]
                                      : [_vm._v("PK")]
                                  ],
                                  2
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand_translux1
                        ? _c("span", { staticClass: "price" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.formatedSelectionPrice || "--"))
                            ])
                          ])
                        : _c("span", { staticClass: "price" }, [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.formatedSelectionPrice || "--") +
                                "\n      "
                            )
                          ])
                    ]
                  )
                : _c(
                    "div",
                    { staticClass: "selectionprice suspended" },
                    [
                      _c("icon", {
                        attrs: {
                          name: "icon-lock",
                          colorName:
                            _vm.brand_translux4 ||
                            _vm.brand_translux3 ||
                            _vm.brand_translux2 ||
                            _vm.brand_translux1 ||
                            _vm.brand_translux
                              ? "white"
                              : "dark"
                        }
                      })
                    ],
                    1
                  )
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a7b1dca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a7b1dca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bettingoffer/selection.vue
// module id = null
// module chunks = 